import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import AppIcons from "../../assets/images/icons";

import './partners.scss';

const PartnersSlider = () => {

  const partnerSlideImgs = [
    {
      partner: AppIcons.partner1,
    },
    {
      partner: AppIcons.partner2,
    },
    {
      partner: AppIcons.partner3,
    },
    {
      partner: AppIcons.partner4,
    },
    {
      partner: AppIcons.partner5,
    },
    {
      partner: AppIcons.partner6,
    },
    {
      partner: AppIcons.partner7,
    },
  ];

  return (
    <div className='partners-slider f-wrp'>
      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        modules={[Navigation]}
        navigation
        loop
        autoplay={{
          delay: 7000,
          disableOnInteraction: false,
        }}
        // pagination={{
        //   dynamicBullets: false,
        //   dynamicMainBullets: 0,
        // }}
        className='partners-item-wrp'
        breakpoints={{
          10: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          767: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        }}>

        {partnerSlideImgs.map((element, key) => (
          <SwiperSlide key={key} className="each-partners-items f-wrp">
            <span>
              <img src={element.partner} alt='partners' />
            </span>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default PartnersSlider;